import React from 'react';
import { Box, ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import WmsNavBar from './WmsNavBar';
import { WmsPermissions } from './useWmsSession';

type ScreenKey = 'picking' | 'packing' | 'receiving' | 'cyclecount';

interface WmsFullScreenLayoutProps {
  children: React.ReactNode;
  currentScreen: ScreenKey;
  cashierName: string;
  wmsPermissions: WmsPermissions;
  onLogout: () => void;
  extraLeftActions?: React.ReactNode;
}

const wmsSoftTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1565c0' },
    secondary: { main: '#5e35b1' },
    background: { default: '#f5f7fb', paper: '#ffffff' },
    text: { primary: '#102a43', secondary: '#486581' },
    divider: '#d9e2ec',
  },
  typography: {
    fontSize: 16,
    fontFamily: '"Poppins", "Roboto", "Arial", sans-serif',
    button: { textTransform: 'none' as const },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { minHeight: 44, borderRadius: 10, fontWeight: 600 },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { minWidth: 44, minHeight: 44, borderRadius: 10 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          border: '1px solid #d9e2ec',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 600,
        },
      },
    },
  },
});

const WmsFullScreenLayout: React.FC<WmsFullScreenLayoutProps> = ({
  children, currentScreen, cashierName, wmsPermissions, onLogout, extraLeftActions,
}) => {
  return (
    <ThemeProvider theme={wmsSoftTheme}>
      <CssBaseline />
      <Box sx={{
        height: '100vh', width: '100vw', overflow: 'hidden',
        display: 'flex', flexDirection: 'column',
        bgcolor: 'background.default',
      }}>
        <WmsNavBar
          currentScreen={currentScreen}
          cashierName={cashierName}
          wmsPermissions={wmsPermissions}
          onLogout={onLogout}
          extraLeftActions={extraLeftActions}
        />
        <Box sx={{ flex: 1, overflow: 'auto' }}>
          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default WmsFullScreenLayout;
